var _path, _mask, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryLow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.89543 0 2 0H11.2307V12H2C0.895432 12 0 11.1046 0 10V2Z",
    fill: "#A32C06"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4176_27234",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447715 0.447715 0 1 0H17.5387C18.091 0 18.5387 0.447715 18.5387 1V11C18.5387 11.5523 18.091 12 17.5387 12H1C0.447715 12 0 11.5523 0 11V1Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H1V1V0V-1C-0.104569 -1 -1 -0.10457 -1 1H0ZM1 0V1H17.5387V0V-1H1V0ZM17.5387 0V1H18.5387H19.5387C19.5387 -0.104569 18.6433 -1 17.5387 -1V0ZM18.5387 1H17.5387V11H18.5387H19.5387V1H18.5387ZM18.5387 11H17.5387V12V13C18.6432 13 19.5387 12.1046 19.5387 11H18.5387ZM17.5387 12V11H1V12V13H17.5387V12ZM1 12V11H1H0H-1C-1 12.1046 -0.104571 13 1 13V12ZM0 11H1V1H0H-1V11H0Z",
    fill: "#171717",
    mask: "url(#path-2-inside-1_4176_27234)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5303 4.19531C17.5303 3.64303 17.978 3.19531 18.5303 3.19531H20.1814C20.7337 3.19531 21.1814 3.64303 21.1814 4.19531V7.80616C21.1814 8.35845 20.7337 8.80616 20.1814 8.80616H18.5303C17.978 8.80616 17.5303 8.35845 17.5303 7.80616V4.19531Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryLow);
export default __webpack_public_path__ + "static/media/batteryLow.5bba16806edbabfd079131e37c0b063a.svg";
export { ForwardRef as ReactComponent };